@if (isInit && locale) {
    <div class="question-page">
        @for (section of activePage.sections; track section) {
            <div class="question-section">
                @if (!section.disabled && !section.options?.hidden) {
                    <div>
                        @if (translateService.keyExists('section.' + section.sectionCode + '.title')) {
                            <h2 class="section-title question-section__title">
                                {{ 'section.' + section.sectionCode + '.title' | translate }}
                            </h2>
                        }
                        <div class="card mb-0 overflow-hidden">
                            @if (section.options?.isHighlighted) {
                                <p-message severity="info" class="mb-3">
                                    <ng-template #icon>
                                        <span class="material-symbols-outlined icon-md" aria-hidden="true"
                                            >family_star</span
                                        >
                                    </ng-template>
                                    {{ 'common.highlighted-label' | translate }}
                                </p-message>
                            }
                            @if (section.options?.subSections) {
                                <div>
                                    <p-tabs [value]="0">
                                        <p-tablist>
                                            @for (
                                                subSection of section.options?.subSections;
                                                track subSection;
                                                let i = $index
                                            ) {
                                                <p-tab [value]="i">
                                                    {{ 'section.' + subSection.sectionCode + '.title' | translate }}
                                                </p-tab>
                                            }
                                        </p-tablist>
                                        <p-tabpanels>
                                            @for (
                                                subSection of section.options?.subSections;
                                                track subSection;
                                                let i = $index
                                            ) {
                                                <p-tabpanel [value]="i">
                                                    @if (
                                                        translateService.keyExists(
                                                            'section.' + subSection.sectionCode + '.note'
                                                        )
                                                    ) {
                                                        <p-message severity="info" icon="ms ms-info" class="mb-3">
                                                            {{
                                                                'section.' + subSection.sectionCode + '.note'
                                                                    | translate
                                                            }}
                                                        </p-message>
                                                    }
                                                    @for (
                                                        question of config.questionsPerPage[activePage.pageCode][
                                                            subSection.sectionCode
                                                        ];
                                                        track question
                                                    ) {
                                                        <div>
                                                            @if (
                                                                !externalUpdates.has(question.questionCode) &&
                                                                !question.option?.isSubQuestion
                                                            ) {
                                                                <app-question
                                                                    [question]="question"
                                                                    [domainPerCode]="config.domainPerCode"
                                                                    [orgId]="organizationId"
                                                                    [questionnaireId]="questionnaireId"
                                                                    [locale]="locale"
                                                                    [pageQuestions]="
                                                                        config.questionsPerPage[activePage.pageCode][
                                                                            subSection.sectionCode
                                                                        ]
                                                                    "
                                                                    [currentEntityFte]="currentEntityFte">
                                                                </app-question>
                                                            }
                                                        </div>
                                                    }
                                                </p-tabpanel>
                                            }
                                        </p-tabpanels>
                                    </p-tabs>
                                </div>
                            }
                            <div class="section-container">
                                @for (
                                    question of config.questionsPerPage[activePage.pageCode][section.sectionCode];
                                    track question
                                ) {
                                    <div>
                                        @if (!externalUpdates.has(question.questionCode)) {
                                            <app-question
                                                [question]="question"
                                                [domainPerCode]="config.domainPerCode"
                                                [orgId]="organizationId"
                                                [questionnaireId]="questionnaireId"
                                                [locale]="locale"
                                                [currentEntityFte]="currentEntityFte">
                                            </app-question>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
}
